import React from 'react'
import { Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'

type StatusChipProps = {
    status: string
}

export const StatusChip: React.FC<StatusChipProps> = ({ status }) => {
    const { t } = useTranslation()
    switch (status) {
        case 'OPEN':
            return <Chip label={t('calendar.open')} color="default" variant="outlined" />
        case 'RELEASED':
            return <Chip label={t('calendar.released')} color="success" variant="filled" />
        case 'SAVED':
            return <Chip label={t('calendar.saved')} color="success" variant="outlined" />
        case 'ABSENCE':
            return <Chip label={t('calendar.absence')} color="primary" style={{ color: 'rgb(107, 0, 138)' }} variant="filled" />
        case 'HOLIDAY':
            return <Chip label={t('calendar.holiday')} color="primary" style={{ color: 'rgb(107, 0, 138)' }} variant="filled" />
        case 'WEEKEND':
            return <Chip label={t('calendar.open')} color="default" variant="outlined" />
        case 'NOTRECORDED':
            return <Chip label={t('calendar.notrecorded')} color="warning" variant="filled" />
        default:
            return null
    }
}